/** Resolves pet IDs to a comma-separated name string via a pre-built lookup. */
export function resolvePetNames(petIds: string[], namesById: Map<string, string>): string {
  if (petIds.length === 0) return ''
  return petIds
    .map((id) => namesById.get(id) ?? '')
    .filter(Boolean)
    .join(', ')
}
